module.exports = __webpack_public_path__ + "media/images/ava-transparente-cabeca-be97f8f1d20f4c7f4d8b1cd057cd09aa.png";